import Head from "next/head";
import React from "react";

function SharedJobHeader(props) {
  // Checks company name to exclude trailing words
  let companyNameInput = props.job?.company?.name;
  let metaIndex = props.job?.expired;
  let excludedWords = [
    "sdn. bhd.",
    "sdn bhd",
    "sendirian bhd",
    "sdn berhad",
    "sendirian berhad",
  ];
  let regex = new RegExp("\\b(" + excludedWords.join("|") + ")\\b", "gi");
  let companyName = companyNameInput.replace(regex, "").trim();

  let metaTitle =
    props.job == undefined
      ? "New Jobs in Malaysia | Hiredly - Where good careers are built"
      : props.job?.company?.id === "750524cc-6b5d-48c8-8438-0b5b1c3f6aea"
      ? `${props.job?.title} could be your next role | Hiredly X Malaysia`
      : `${props.job?.title} at ${companyName} | Hiredly Malaysia`;

  let metaDescription =
    props.job == undefined
      ? "Apply now on Hiredly Malaysia. Find the right job fo you."
      : props.job?.company?.id === "750524cc-6b5d-48c8-8438-0b5b1c3f6aea"
      ? "Apply now & our headhunters will be in contact | Hiredly X Malaysia"
      : `Apply now for ${props.job?.title} at ${companyName} on Hiredly Malaysia. Find the right job for you.`;

  return (
    <Head>
      {/* <!-- Google jobs structured data --> */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(props.job?.structuredJobData),
        }}
      />

      {/* <!-- Primary Meta Tags --> */}
      <title>{metaTitle}</title>
      <meta property="" content="initial-scale=1.0, width=device-width" />
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      {/* {metaIndex && <meta name="robots" content="noindex, nofollow" />} */}

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={`https://my.hiredly.com/jobs/${props.job?.slug}`}
      />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={`https:` + props.job?.imageThumb} />

      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:url"
        content={`https://my.hiredly.com/jobs/${props.job?.slug}`}
      />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta
        property="twitter:image"
        content={`https:` + props.job?.imageThumb}
      />

      <link
        rel="canonical"
        href={`https://my.hiredly.com/jobs/${props.job?.slug}`}
      />
    </Head>
  );
}

export default SharedJobHeader;
